package com.kinoshazam.data

import kotlin.concurrent.Volatile

/**
 * Holds password only in memory for the email-verification OTP step.
 * Avoids putting credentials into navigation routes / saved state.
 */
class PendingAuthCredentials {
    @Volatile
    private var email: String? = null

    @Volatile
    private var password: String? = null

    fun put(email: String, password: String) {
        this.email = email
        this.password = password
    }

    /** Returns password if it matches [email], then clears the stash. */
    fun takePassword(email: String): String? {
        val storedEmail = this.email
        val storedPassword = this.password
        clear()
        return if (storedEmail != null &&
            storedEmail.equals(email, ignoreCase = true) &&
            !storedPassword.isNullOrEmpty()
        ) {
            storedPassword
        } else {
            null
        }
    }

    fun clear() {
        email = null
        password = null
    }
}
